import React, { useCallback, useContext, useState } from 'react';

import { ReactComponent as ArrowRightIcon } from '../../../../../../../assets/icons/v2/arrow-right.svg';
import { PrimaryButton } from '../../../../../../../components/Button/ActionButtons';
import MealPlan from '../../../../../../Model/MealPlan';
import MealPlanContext from '../../../../../../context/MealPlanContext';
import UserContext from '../../../../../../../context/UserContext';
import useToast from '../../../../../../hooks/useToast';
import useMealPlanNavigation from '../../../../../../hooks/useMealPlanNavigation';
import { MealPlannerType } from '../../../../../../routes/mealPlanner/mealPlannerPages';
import LoadingOverlay from '../../../../../../components/LoadingOverlay';
import {
  StyledTitledActionContainerSection,
  StyledTypography,
} from '../styles';

import texts from './texts.json';

const AutomationTemplate = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { showToast } = useToast();
  const { userId: coachId } = useContext(UserContext);
  const { setAutomationTemplate } = useContext(MealPlanContext);
  const { navigateToTab } = useMealPlanNavigation();

  const handleEditTemplate = useCallback(async () => {
    setIsLoading(true);
    try {
      const automationTemplateDoc = await MealPlan.getAutomationTemplate(coachId);

      if (!automationTemplateDoc) {
        showToast(texts.errors.loadError, { error: true });
        return;
      }

      setAutomationTemplate(automationTemplateDoc);
      navigateToTab(MealPlannerType.MANAGE_MEAL_PLANS, {
        search: 'editAutomationTemplate=true',
      });
    } catch (error) {
      showToast(texts.errors.loadError, { error: true });
    } finally {
      setIsLoading(false);
    }
  }, [
    coachId,
    navigateToTab,
    setAutomationTemplate,
    showToast,
  ]);

  return (
    <>
      <StyledTitledActionContainerSection>
        <StyledTypography>{texts.description}</StyledTypography>
        <PrimaryButton
          onClick={handleEditTemplate}
          disabled={isLoading}
          endIcon={<ArrowRightIcon />}
          $fitToContent
          variant="light"
        >
          {texts.edit}
        </PrimaryButton>
      </StyledTitledActionContainerSection>
      <LoadingOverlay isLoading={isLoading} />
    </>
  );
};

export default AutomationTemplate;
